"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.413,
    height: 23.413,
    fill: "#29B200",
    rx: 11.707
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "m8.12 17.253-3.195.958 1.038-3.17a6.882 6.882 0 1 1 2.158 2.212z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m10.616 9.568-.488-1.173c-.094-.223-.263-.322-.505-.295-.363.04-.674.084-1.023.732-.348.647-.29 1.313-.145 1.685.145.372.74 1.523 1.61 2.374.58.568 1.427 1.088 2.545 1.56.833.233 1.422.305 1.765.217.515-.132.916-.56 1.047-.856.13-.297.208-.685 0-.803a40.92 40.92 0 0 0-1.383-.683c-.18-.112-.336-.072-.469.12-.133.19-.356.429-.67.715-.774-.206-1.336-.484-1.685-.835s-.711-.826-1.087-1.423a.331.331 0 0 1 .151-.386c.21-.139.19-.094.337-.322.099-.152.099-.36 0-.627z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgWhatsapp);
var _default = exports["default"] = Memo;